// Import paths
import { MAIN_PATHS } from 'components/routes/paths';

const { INSTITUTIONS } = MAIN_PATHS;

export const INSTITUTIONS_PATHS = {
	INSTITUTIONS_LIST: INSTITUTIONS,
	INSTITUTION_DETAILS: `${INSTITUTIONS}/:institutionUuid/:institutionName`
};
